import {
    STATUS_PROJECT,
    STATUS_BUNDLE,
    STATUS_OPTION,
    STATUS_PAYMENT,
    STATUS_ORDER,
    STATUS_PRIVACY,
    STATUS_TEACHER,
    STATUS_TEACHER_PDF,
    STATUS_PAYEVER_CHANGE_PDF,
    STATUS_SEPA,
    STATUS_CHECKOUT,
    STATUS_CHECKOUT_DEP,
    STATUS_FINISH,
    STATUS_SUBMIT,
    STATUS_RESET,
    STATUS_UPLOAD,
    STATUS_SERIAL
} from '../constants';

// import LocalStorageUtils from '../utils/LocalStorageUtils';

export function resetAll() {
    return {
        type: STATUS_RESET,
        payload: {}
    }
}
export function setProject(project) {
    return {
        type: STATUS_PROJECT,
        payload: {
            isset: true,
            name: project.name,
            id: project.id,
            teachers: project.teachers,
            isDep: project.isDep,
            requestSerial: project.requestSerial,
            data: {
                bundles: project.bundles,
                payments: project.payments,
                description: project.description,
                support: project.support,
                customdata: project.customdata
                // customdata: []
            }
        }
    }
}

export function resetProject() {
    return {
        type: STATUS_PROJECT,
        payload: {
        	isset: false,
        	name: '',
            id: 0,
        	teachers: false,
            isDep: false,
            requestSerial: false,
        	data: {}
        }
    }
}

export function setSerial(sn) {
    return {
        type: STATUS_SERIAL,
        payload: {
            isset: true,
            sn: sn
        }
    }
}

export function resetSerial() {
    return {
        type: STATUS_SERIAL,
        payload: {
            isset: false,
            sn: ''
        }
    }
}
export function setBundle(bundle) {
    return {
        type: STATUS_BUNDLE,
        payload: {
            isset: true,
            id: bundle.id
        }
    }
}

export function resetBundle() {
    return {
        type: STATUS_BUNDLE,
        payload: {
            isset: false,
            id: 0
        }
    }
}


export function setOptions(obj) {
    return {
        type: STATUS_OPTION,
        payload: {
            isset: obj.isset,
            articles: obj.articles,
            articleConfig: obj.articleConfig,
            bundleId: obj.bundleId
        }
    }
}

export function disableOptions() {
    return {
        type: STATUS_OPTION,
        payload: {
            isset: false
        }
    }
}

export function resetOptions() {
    return {
        type: STATUS_OPTION,
        payload: {
            isset: false,
            articles: [],
            articleConfig: [],
            bundleId: 0
        }
    }
}

export function setPayment(obj) {
    return {
        type: STATUS_PAYMENT,
        payload: {
            isset: true,
            paymentOption:obj.paymentOption,
            paymentPrice:obj.paymentPrice,
            paymentRuntime:obj.paymentRuntime,
            type: obj.type,
            group: obj.group,
            id: obj.id,
            bundleId: obj.bundleId
        }
    }
}

export function resetPayment() {
    return {
        type: STATUS_PAYMENT,
        payload: {
            isset: false,
            paymentOption:'',
            paymentPrice:'',
            paymentRuntime:0,
            type: '',
            group: '',
            id: '',
            bundleId: 0
        }
    }
}

export function setOrder(obj) {
    return {
        type: STATUS_ORDER,
        payload: {
            isset: true,
            form: obj.form
        }
    }
}

export function resetOrder() {
    return {
        type: STATUS_ORDER,
        payload: {
            isset: false,
            form: {}
        }
    }
}
export function setPrivacy(obj) {
    return {
        type: STATUS_PRIVACY,
        payload: {
            isset: true,
            checkbox: true
        }
    }
}

export function resetPrivacy() {
    return {
        type: STATUS_PRIVACY,
        payload: {
            isset: false,
            checkbox: false
        }
    }
}
export function setTeacher(obj) {
    return {
        type: STATUS_TEACHER,
        payload: {
            isset: true,
            checkbox: true
        }
    }
}

export function resetTeacher() {
    return {
        type: STATUS_TEACHER,
        payload: {
            isset: false,
            checkbox: false
        }
    }
}
export function setTeacherOverlay() {
    return {
        type: STATUS_TEACHER_PDF,
        payload: {
            shown: true
        }
    }
}
export function resetTeacherOverlay() {
    return {
        type: STATUS_TEACHER_PDF,
        payload: {
            shown: false
        }
    }
}
export function setPayeverChangeOverlay() {
    return {
        type: STATUS_PAYEVER_CHANGE_PDF,
        payload: {
            shown: true
        }
    }
}
export function resetPayeverChangeOverlay() {
    return {
        type: STATUS_PAYEVER_CHANGE_PDF,
        payload: {
            shown: false
        }
    }
}
export function setSepa(obj) {
    return {
        type: STATUS_SEPA,
        payload: {
            isset: true,
            checkbox: true
        }
    }
}

export function resetSepa() {
    return {
        type: STATUS_SEPA,
        payload: {
            isset: false,
            checkbox: false
        }
    }
}
export function setFinish(obj) {
    return {
        type: STATUS_FINISH,
        payload: {
            isset: true
        }
    }
}

export function resetFinish() {
    return {
        type: STATUS_FINISH,
        payload: {
            isset: false
        }
    }
}

export function setCheckout() {
    return {
        type: STATUS_CHECKOUT,
        payload: {
            isset: true,
            checkbox: true
        }
    }
}

export function resetCheckout() {
    return {
        type: STATUS_CHECKOUT,
        payload: {
            isset: false,
            checkbox: false
        }
    }
}
export function setCheckoutDep(payload) {
    return {
        type: STATUS_CHECKOUT_DEP,
        payload: {
            isset: payload.isset,
            checkboxes: payload.checkboxes
        }
    }
}

export function resetCheckoutDep() {
    return {
        type: STATUS_CHECKOUT_DEP,
        payload: {
            isset: false,
            checkboxes: []
        }
    }
}

export function setUpload(files) {
    return {
        type: STATUS_UPLOAD,
        payload: {
            files: files
        }
    }
}

export function resetUpload() {
    return {
        type: STATUS_UPLOAD,
        payload: {
            files: []
        }
    }
}


export function setSubmit(payload) {
    return {
        type: STATUS_SUBMIT,
        payload: {
            status: payload.status,
            data: payload.data,
            msg: payload.msg
        }
    }
}
export function resetSubmit() {
    return {
        type: STATUS_SUBMIT,
        payload: {
            status: false,
            msg: false
        }
    }
}



// WEBPACK FOOTER //
// ./src/actions/status.js